import PostAPI from "./PostAPI";

const PostApiClient = new PostAPI();

export default PostApiClient;